export enum DropdownMenuNames {
  CPD_DOWNLOAD = 'CPD_DOWNLOAD',
  FILES_DOWNLOAD = 'DOWNLOAD', // 'FILES_DOWNLOAD',
  SAVED_ITEMS_ADD = 'SAVED_ITEMS_ADD',
  SAVED_ITEMS_REMOVE = 'SAVED_ITEMS_REMOVE',
}
